export { default } from 'features/reward/routes/rewards-how-it-works-route';
